import palette from "./data/colors.json";

const colors = {
  background: palette.black,
  backgroundDay: palette.darkerBrown,
  backgroundNight: palette.darkerBlue,
  text: palette.white,
  primary: palette.red,
  secondary: palette.lightBlue,
  invalid: palette.red,
  warning: palette.yellow,
  blueprint: palette.lightBlue,
  player: palette.white,
  inactiveBuilding: palette.gray,
  activeBuilding: palette.lessLightGray,
  mineral: palette.brown,
  mountain: palette.darkBrown,
  enemyUnit: palette.purple,
  enemyBuilding: palette.darkPurple,
  water: palette.blue,
  laser: palette.red,
  power: palette.yellow,
  ground: palette.darkGray,
  food: palette.green,
};

export default colors;
